export const getUserBrowserLanguage = () =>
  window.navigator.languages && window.navigator.languages?.length
    ? window.navigator.languages[0]
    : window.navigator.language;
